import * as React from "react";
import { Box } from "@mui/material";
import StackList from "./stackList";
import { formatCurrency, getChargeRows } from "../utils";
import KeyValueText, { IKeyValueText } from "./KeyValueText";
import { useTranslation } from "react-i18next";
import { useGlobalContext } from "../context/globalContext";

// `currency` is the paid service's own unit, passed on the confirm step where
// no pay response exists yet. After a payment the session holds the unit the
// server named, and that wins.
const ServiceChargeSummary = ({
  currency,
  ...rest
}: { currency?: string } & Record<string, unknown>) => {
  const { t } = useTranslation();
  const {
    totalAmount,
    totalFees,
    instrumentFee,
    registrationFee,
    currency: paidCurrency,
  } = useGlobalContext();
  const unit = paidCurrency || currency;

  // Shared with the receipt so the two screens cannot tell a payer two
  // different stories about the same charge. The total row is upstream's
  // aggregate, never a sum of the components above it.
  const listData: IKeyValueText[] = getChargeRows(
    instrumentFee,
    registrationFee,
    totalFees
  ).map(row => ({
    title: t(row.titleKey),
    value: formatCurrency(row.value, undefined, unit),
  }));
  return (
    <Box
      sx={{ bgcolor: "#E2E2E2", py: 1.5, mt: -4, borderRadius: 1 }}
      {...rest}
    >
      <StackList spacing={2} list={listData} margin={2} />
      <KeyValueText
        title={t("payment.form.total_amount")}
        value={formatCurrency(totalAmount, undefined, unit)}
        valueStyles={{
          fontSize: 30,
          color: "#D92D20",
          fontWeight: "600",
          marginTop: 2,
          marginRight: 2,
        }}
        titleStyles={{ fontSize: 20, color: "black", marginLeft: 2 }}
      />
    </Box>
  );
};

export default ServiceChargeSummary;
